[
  {
    "id": "gmail",
    "name": "Gmail",
    "category": "Email",
    "icon": "envelope",
    "color": "#C53929",
    "url": "https://mail.google.com/",
    "description": "Find emails, summarize conversations, and draft replies.",
    "prompt": "Summarize my recent unread emails in Gmail and highlight anything that needs a reply."
  },
  {
    "id": "google-drive",
    "name": "Google Drive",
    "category": "Documents",
    "icon": "folder",
    "color": "#237D44",
    "url": "https://drive.google.com/",
    "description": "Find and work with files, Docs, Sheets, and Slides.",
    "prompt": "Find my recently edited files in Google Drive and summarize what each one is about."
  },
  {
    "id": "google-calendar",
    "name": "Google Calendar",
    "category": "Productivity",
    "icon": "calendar",
    "color": "#2864C5",
    "url": "https://calendar.google.com/",
    "description": "Review your schedule and plan meetings.",
    "prompt": "Review my Google Calendar for the coming week and highlight scheduling conflicts."
  },
  {
    "id": "github",
    "name": "GitHub",
    "category": "Development",
    "icon": "code-branch",
    "color": "#343434",
    "url": "https://github.com/",
    "description": "Review pull requests, issues, and build checks.",
    "prompt": "Review my open GitHub pull requests and summarize which ones need attention."
  },
  {
    "id": "gitlab",
    "name": "GitLab",
    "category": "Development",
    "icon": "code-merge",
    "color": "#B44B1A",
    "url": "https://gitlab.com/",
    "description": "Review merge requests, issues, and pipelines.",
    "prompt": "Review my open GitLab merge requests and summarize failed pipelines and outstanding feedback."
  },
  {
    "id": "notion",
    "name": "Notion",
    "category": "Documents",
    "icon": "book",
    "color": "#343434",
    "url": "https://www.notion.so/",
    "description": "Find notes and organize pages and project information.",
    "prompt": "Find my recent project notes in Notion and summarize open action items."
  },
  {
    "id": "slack",
    "name": "Slack",
    "category": "Communication",
    "icon": "hashtag",
    "color": "#65376A",
    "url": "https://app.slack.com/",
    "description": "Catch up on channels and find team conversations.",
    "prompt": "Summarize my recent Slack mentions and highlight questions waiting for my reply."
  },
  {
    "id": "proton-mail",
    "name": "Proton Mail",
    "category": "Email",
    "icon": "envelope",
    "color": "#6D4BC2",
    "url": "https://mail.proton.me/",
    "description": "Find emails, summarize threads, and prepare replies.",
    "prompt": "Summarize my recent unread emails in Proton Mail and highlight anything that needs a reply."
  }
]
